"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
class HttpNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.HTTP };
    if (props.type !== types_1.NODE_TYPES.HTTP)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializeData = {
      headers: [],
      methodName: types_1.HttpMethodType.GET,
      body: "",
      url: ""
    };
    if (nodeData) {
      let modified = nodeData.body;
      if (nodeData.body && typeof nodeData.body !== "string") {
        modified = JSON.stringify(nodeData.body, null, 2);
      }
      let { headers } = nodeData;
      if (!headers) headers = {};
      let modifiedHeaders = Object.keys(headers).map(key => ({
        key,
        value: headers[key]
      }));
      deserializeData = {
        methodName: nodeData.methodName,
        body: modified,
        url: nodeData.url,
        basicAuth: nodeData.basicAuth,
        headers: modifiedHeaders
      };
    }
    return deserializeData;
  }
  serialize(uiData) {
    let parsed,
      body = uiData.body;
    try {
      parsed = JSON.parse(body);
    } catch (e) {
      parsed = body;
    }
    let data = {
      methodName: uiData.methodName,
      body: parsed,
      url: uiData.url,
      basicAuth: uiData.basicAuth,
      headers: uiData.headers.reduce((a, e) => {
        a[e.key] = e.value;
        return a;
      }, {})
    };
    return data;
  }
  async getAvailableResources() {
    let availableResources = [];
    availableResources.push({
      nodeRef: this,
      selectedResourceId: this.id,
      path: "",
      label: [this.getNodeName(), "Response"].join("."),
      context: {
        outputPath: ""
      }
    });
    return availableResources;
  }
  validate() {
    return new validations_1.HttpNodeValidators().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.HttpNode = HttpNode;
/*

use equals or not eqALS IN WEBAPP. (MAKE SURE TO USE THIS FUNCTION TO PROVIDE COMPATIBILITY FOR EXISTING WORKFLOWS);
CHANGE MODAL TITLE TO NODE IDS AND NODE NAME


 */
/*
  npm run build
  rm -rf ../webapp/node_modules/workflow-model/dist/
  rm -rf ../webapp/node_modules/workflow-model/src/
  cp -r dist ../webapp/node_modules/workflow-model/dist
  cp -r src ../webapp/node_modules/workflow-model/src


  rm -rf ../dag-vis/node_modules/workflow-model/dist/
  rm -rf ../dag-vis/node_modules/workflow-model/src/
  cp -r dist ../dag-vis/node_modules/workflow-model/dist
  cp -r src ../dag-vis/node_modules/workflow-model/src


  npm run build
  rm -rf ../webapp-engine/node_modules/workflow-model/dist/
  rm -rf ../webapp-engine/node_modules/workflow-model/src/
  cp -r dist ../webapp-engine/node_modules/workflow-model/dist
  cp -r src ../webapp-engine/node_modules/workflow-model/src

 */
//# sourceMappingURL=HttpNode.js.map
